import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    standalone: true,
    imports: [NgClass, NgIf, MatIconModule, TranslateModule]
})
export class ButtonComponent {

  @Input()
  label: string;

  @Input()
  icon: string;

  @Input()
  labelArguments: any = {};

  @Input()
  isDisabled: boolean;

  @Output()
  public onclick: EventEmitter<Event> = new EventEmitter<Event>();

  onClick(event: Event) {
    event.stopPropagation();
    this.onclick.emit(event);
  }

}
